module.exports = __webpack_public_path__ + "static/media/freshgrocer-downtimedollars-logo-horizontal.09aad77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-downtimedollars-logo-horizontal.png
// module id = 352
// module chunks = 0